(function(ko){
	'use strict';

	ko.bindingHandlers.stopBindings = {
	    init: function() {
	        return { controlsDescendantBindings: true };
	    }
	};
})(ko);